/* eslint-disable import/prefer-default-export */

export const togglePasswordVisibility = fieldToChange => {
  if (fieldToChange.type === 'password') {
    fieldToChange.type = 'text';
  } else {
    fieldToChange.type = 'password';
  }
};
